import { render, staticRenderFns } from "./CompanyCourseDetails.vue?vue&type=template&id=3acd23bc&scoped=true"
import script from "./CompanyCourseDetails.vue?vue&type=script&lang=js"
export * from "./CompanyCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourseDetails.vue?vue&type=style&index=0&id=3acd23bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd23bc",
  null
  
)

export default component.exports